import { useEffect } from "react";

import { useShallow } from "zustand/react/shallow";

import { useUserTriggeredModalsStore } from "../user-triggered-modals.store";
import { useUserTriggeredModalsHistoryState } from "./use-modal-history-states";

export const useUserTriggeredModalHistoryUpdates = () => {
  const [historyState] = useUserTriggeredModalsHistoryState();

  const openModalIds = useUserTriggeredModalsStore(useShallow((state) => state.openIds));
  const setOpenModalIds = useUserTriggeredModalsStore((state) => state.setOpenIds);
  const modalArgs = useUserTriggeredModalsStore((state) => state.args);
  const modalStates = useUserTriggeredModalsStore((state) => state.state);
  const setModalArgs = useUserTriggeredModalsStore((state) => state.setArgs);
  const setModalState = useUserTriggeredModalsStore((state) => state.setState);

  useEffect(() => {
    const requestedModalIds = historyState.map((modal) => modal.id);
    if (arraysMatch(requestedModalIds, openModalIds)) {
      return;
    }

    for (const id of requestedModalIds) {
      const { args, state } = historyState.find((modal) => modal.id === id)!;
      setModalArgs(id, modalArgs[id] ?? args ?? {});
      setModalState(id, modalStates[id] ?? state);
    }

    setOpenModalIds(requestedModalIds);
  }, [openModalIds, historyState, setModalArgs, setOpenModalIds, modalArgs, modalStates, setModalState]);
};

const arraysMatch = <T>(array1: T[], array2: T[]) => {
  if (array1.length !== array2.length) {
    return false;
  }

  return array1.every((val, i) => val === array2[i]);
};
